import PropTypes from 'prop-types'
import classnames from 'classnames'

import * as consts from 'registry/constants'
import { LinkButton } from 'components/buttons'
import { CONFIG } from 'shared/constants'

const VisibilityStatus = ({ hasVisitorPassword, onClick, searchLevel }) => {
  const searchLevelOptions = CONFIG.registry.searchLevelOptions

  let icon
  let privacyText
  let visibilityText
  switch (searchLevel) {
    case searchLevelOptions.public:
    case searchLevelOptions.babylist:
      icon = 'fa-globe'
      privacyText = 'Public'
      visibilityText = `Visitors can search Babylist${
        searchLevel === searchLevelOptions.public ? ' and Google' : ''
      } to find your registry${
        hasVisitorPassword ? ' and need the guest password' : ''
      }.`
      break
    default:
      icon = 'fa-lock'
      privacyText = 'Private'
      visibilityText = `Visitors must have the link to your registry${
        hasVisitorPassword ? ' and the guest password' : ''
      }.`
  }

  return (
    <div className="h7">
      <LinkButton className="edit-privacy h7 man pan" onClick={onClick}>
        <span className="text-body">
          <i className={classnames('fa', icon, 'small text-light')} />
          {` Your Registry is `}
        </span>
        <strong>{privacyText}</strong>
        <span className="text-body">.</span>
      </LinkButton>
      <div className="h7">{visibilityText}</div>
    </div>
  )
}

VisibilityStatus.propTypes = {
  hasVisitorPassword: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  searchLevel: PropTypes.string.isRequired,
}

export default VisibilityStatus
